<template>
    <div ref="map" class="w-full h-[300px] md:h-[500px] relative z-0" v-if="data"></div>
</template>

<script>
    export default {
        name: 'RealizationsMap',
        props: {
            data: {
                type: Array,
                default: null,
                required: true,
            },
        },
        methods: {
            createMap() {
                const mymap = L.map(this.$refs.map, {
                    scrollWheelZoom: false,
                })

                if (this.data.length) {
                    mymap.setView([this.data[0].Lat, this.data[0].Lon], 6)
                } else {
                    mymap.setView([52.15878937449872, 19.1655280166752], 6)
                }
                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {}).addTo(mymap)
                this.data.forEach((el) => {
                    if (el.Lat && el.Lon) {
                        let newMarker = new L.marker([el.Lat, el.Lon]).addTo(mymap)
                        let popupText = `<div>
                            <div class="font-bold text-primary mb-2">${el.Name}</div>
                        </div>`
                        newMarker.bindPopup(popupText)
                    }
                })
            },
        },
        mounted() {
            this.createMap()
        },
    }
</script>

<style></style>
